export var DEPLOY_DATE = new Date('2026-07-14T06:21:55+0000');
